import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { IconButton, Icon } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import { Helmet } from 'react-helmet';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import GAListener from './utils/GAListerner';

// Pages
import AppPage from './painel/App';
import LoginPage from './painel/pages/auth/entrar';
import RouterWeb from './web/App';
// import RouterLojista from './lojista/App';
import ScrollToTop from './web/components/ScrollToTop';

//Services
import Session from './services/auth/Session';
import InformacaoAPI from './services/api/Configuracao';

//Intro
// import Intro from './painel/Auth/IntroLoader';

const theme = createMuiTheme({
	palette: {
	  primary: {
		light: '#ef9f3f',
		main: '#ec870f',
		dark: '#a55e0a',
		contrastText: '#fff',
	  },
	},
	typography: {
		useNextVariants: true,
	},
  });

class RoteadorPrivado extends React.Component {
    state = {
        loading: true,
    }
	refreshValidacao = () => {
		Session.ValidaToken()
			.then((rs) => rs.json())
            .then((res) => {
                if (res !== true) {
                    this.props.history.push(
                        '/painel/entrar?to=' +
                        this.props.history.location.pathname +
                        this.props.history.location.search);
                    return;
				}
				Session.RefreshCredentials();
                this.setState({ loading: false });
		    });
	}

    componentDidMount() {
		this.refreshValidacao();
    }

    render() {
		const { loading } = this.state;
        if (loading === true) return null;
        return <AppPage />;
    }
}

// class RoteadorLojista extends React.Component {
//     state = {
//         loading: true,
//     }
// 	refreshValidacao = () => {
// 		Session.ValidaToken()
// 			.then((rs) => rs.json())
//             .then((res) => {
//                 if (res !== true) {
//                     this.props.history.push(
//                         '/lojista/entrar?to=' +
//                         this.props.history.location.pathname +
//                         this.props.history.location.search);
//                     return;
// 				}
// 				Session.RefreshCredentials();
//                 this.setState({ loading: false });
// 		    });
// 	}

//     componentDidMount() {
// 		this.refreshValidacao();
//     }

//     render() {
// 		const { loading } = this.state;
//         if (loading === true) return null;
//         return <RouterLojista />;
//     }
// }

class RoteadorLogin extends React.Component {
	state = {
        loading: true,
	}

	handleStatusLogin = null;

	componentDidMount() {
		this.atualizarStatusLogin();
		this.handleStatusLogin = setInterval(this.atualizarStatusLogin, 15000);
	}

	atualizarStatusLogin = () => {
		let vinculo = Session.GetVinculo();
		let master = Session.IsMaster();
		Session.ValidaToken()
				.then((rs) => rs.json())
				.then((res) => {
					if (res === true) {
						Session.RefreshCredentials();
						if( vinculo !== undefined && master ){
							this.props.history.push('/painel/dashboard');
						}
						return;
					}
					this.setState({ loading: false });
				});
	}

	componentWillUnmount() {
        clearInterval(this.handleStatusLogin);
    }

	render() {
		const { loading } = this.state;
        if (loading === true) return null;
        return <LoginPage history={this.props.history} />;
    }
}

export default class Rota extends React.Component {
	state = {
		title: 'Shopping Norte Sul',
		informacoes:[],
	}

	refreshInformacoes = () => {
		InformacaoAPI.get_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ informacoes: res })
				return;
			})
		});
	}

	componentDidMount(){
		this.refreshInformacoes();
	}

    render() {
		const { title, informacoes } = this.state;
        return (
            <Router>
				<GAListener trackingId={process.env.GA_ID_ACOMPANHAMENTO} >
					<ScrollToTop>
					<div>
						<MuiThemeProvider theme={theme} >
							<Helmet encodeSpecialCharacters={true} titleTemplate={`%s – ${informacoes.titulo ? informacoes.titulo : title}`} />
							<SnackbarProvider maxSnack={4}
											action={<IconButton color="secondary" size="small"><Icon color="secondary" >close</Icon></IconButton>}
											TransitionProps={{direction: 'up'}}>
								<Switch>
									<Route path="/painel/entrar" component={RoteadorLogin} />
									<Route path="/painel" component={RoteadorPrivado} />
									{/* <Route path="/lojista" component={RoteadorLojista} /> */}
									<Route exact path="" component={() => <RouterWeb informacoes={informacoes} />} />
									<Redirect from="*" to="/" />
								</Switch>
							</SnackbarProvider>
						</MuiThemeProvider>
					</div>
					</ScrollToTop>
				</GAListener>
            </Router>
        );
    }
};



// WEBPACK FOOTER //
// ./src/Router.js